<script lang="ts" setup>
import { useTheme } from '@/hooks/useTheme'
import { useLoginStore } from '@/store/modules/login'
import enUS from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import zhHk from 'element-plus/es/locale/lang/zh-hk'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { initTheme } = useTheme()
const { currentLang } = storeToRefs(useLoginStore())

// element國際化
const locale = computed(() => {
  if (currentLang.value === 'en-US') {
    return enUS
  }
  if (currentLang.value === 'zh-CN') {
    return zhCn
  }
  if (currentLang.value === 'zh-HK') {
    return zhHk
  }
  return zhHk
})

/** 初始化主题 */
initTheme()
</script>

<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>
